import { render, staticRenderFns } from "./ComExp.vue?vue&type=template&id=35586737&scoped=true&"
import script from "./ComExp.vue?vue&type=script&lang=js&"
export * from "./ComExp.vue?vue&type=script&lang=js&"
import style0 from "./ComExp.vue?vue&type=style&index=0&id=35586737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35586737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VContainer,VImg})
